import { CustomerMatchRequestBody, CustomerMatchResponse } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export type CustomerMatchCandidate = CustomerMatchResponse['candidates'][number];

export const useMatchCustomer = () => {
  const client = useClient();
  const mutationFn = (body: CustomerMatchRequestBody) =>
    client.post('customer/match', { json: body }).json<CustomerMatchResponse>();

  const result = useMutation({ mutationFn });

  return {
    ...result,
    matchCustomerAsync: result.mutateAsync,
    isMatchingCustomer: result.isPending,
  };
};
